import React from 'react';
import { formatMMtoHHMM } from '@mummssoftware/utils/formatters';
import { VisitHeaderDiv, VisitHeaderDetailDiv, HeaderSpan, VisitHeaderDetailValueDiv } from './WrapperDiv';
import { defaults } from './en';
export const VisitHeader = ({
  dto
}) => {
  if (!dto) return null;
  const {
    personfirstname,
    personlastname,
    personcredentials,
    durationmins,
    compiledvisittype
  } = dto;
  return /*#__PURE__*/React.createElement(VisitHeaderDiv, null, personfirstname && /*#__PURE__*/React.createElement(VisitHeaderDetailDiv, null, /*#__PURE__*/React.createElement(HeaderSpan, null, `${defaults.provider}:`), /*#__PURE__*/React.createElement(VisitHeaderDetailValueDiv, null, `${personfirstname} ${personlastname}${personcredentials && `, ${personcredentials}` || ''}`)) || null, durationmins && /*#__PURE__*/React.createElement(VisitHeaderDetailDiv, null, /*#__PURE__*/React.createElement(HeaderSpan, null, `${defaults.duration}:`), /*#__PURE__*/React.createElement(VisitHeaderDetailValueDiv, null, `${formatMMtoHHMM(durationmins)}`)) || null, compiledvisittype && /*#__PURE__*/React.createElement(VisitHeaderDetailDiv, null, /*#__PURE__*/React.createElement(HeaderSpan, null, `${defaults.visitType}:`), /*#__PURE__*/React.createElement(VisitHeaderDetailValueDiv, null, `${compiledvisittype}`)) || null);
};